// An audio cue is created this long before its start so its file is loaded
// when the scene gets there (content frames: half the wall time at 2x).
export const AUDIO_PRELOAD_FRAMES = 90;

// Only cues that the scene timeline starts: an explicit timeline start and a
// single file. A cue without one starts itself on mount (autoplay) and a
// sound-list cue runs its own clock, so neither may be created early.
export function preloadsAudioCue(box, toolbarState) {
  if (typeof box?.timeline?.startFrame !== "number") return false;
  const list = toolbarState?.soundList;
  return !(Array.isArray(list) && list.length > 0);
}
